import { CommonModule, NgIf } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core'
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { environment } from '../../../../../environments/environment'
import {
  BehaviorSubject,
  catchError,
  combineLatest,
  concat,
  distinctUntilChanged,
  filter,
  forkJoin,
  interval,
  map,
  Observable,
  of,
  scan,
  shareReplay,
  startWith,
  Subject,
  Subscription,
  switchMap,
  take,
  takeUntil,
  tap,
  timer
} from 'rxjs'
import { AuthState, selectUser, User } from '../../../../store/auth/auth.state'
import { select, Store } from '@ngrx/store'
import { AuthService } from '../../../../services/auth.service'
import { ToastrService } from 'ngx-toastr'
import { loadEmployeeById } from '../../../../store/user/user.actions'
import {
  createClockInClockOut,
  createClockInClockOutFailure,
  createClockInClockOutSuccess,
  getLatestClockIn,
  loadEmployeeAttendance,
  loadEmployeeAttendanceSuccess,
  updateClockIn,
  updateClockInFailure,
  updateClockInSuccess
} from '../../../../store/clockIn-clockOut/clockIn-clockOut.actions'
import { ClockInClockOut } from '../../../../store/clockIn-clockOut/clockIn-clockOut.state'
import {
  selectExpectedWorkHoursThisMonth,
  selectExpectedWorkHoursThisWeek,
  selectExpectedWorkHoursToday,
  selectIsPunchedIn,
  selectTodaysClockinoutRecords,
  selectTotalBreakHoursToday,
  selectTotalOvertimeThisMonth,
  selectTotalOvertimeToday,
  selectTotalProductiveWorkHoursToday,
  selectTotalWorkHoursThisMonth,
  selectTotalWorkHoursThisWeek,
  selectTotalWorkHoursToday
} from '../../../../store/clockIn-clockOut/clockIn-clockOut.selectors'
import { SharedModule } from '../../../../shared/shared.module'
import {
  selectLatestPunchIn,
  selectLoading
} from '../../../../store/clockIn-clockOut/clockIn-clockOut.reducer'
import { Actions, ofType } from '@ngrx/effects'
import { UserService } from '../../../../services/user.service'
import { NotificationService } from '../../../../services/notification.service'
import { eps } from '../../../../services/url.service'
import { WorkStatus } from '../../attendance/calander/calander.component'
import { Notification } from '../../../../store/notification/notification.state'
import { HolidayService } from '../../../../services/holiday.service'
import { Holiday } from '../../leaves/holidays/holidays.component'
import { HasPermissionDirective } from '../../../../directives/has-permission.directive'
import { selectUserPermissions } from '../../../../store/auth/auth.selectors'
import {
  ClockInClockOutService,
  ClockInOutCountResponse
} from '../../../../services/clockIn-clockOut.service'
import {
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexGrid,
  ApexLegend,
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexResponsive,
  ApexStroke,
  ApexTooltip,
  NgApexchartsModule
} from 'ng-apexcharts'
import { NgxDaterangepickerBootstrapDirective } from 'ngx-daterangepicker-bootstrap'
import dayjs from 'dayjs'
import { HasModuleDirective } from '../../../../directives/has-module.directive'
import { AttendanceClockComponent } from './attendance-clock/attendance-clock.component'
export interface ChartOptions {
  series?: ApexNonAxisChartSeries
  chart?: ApexChart
  plotOptions?: ApexPlotOptions
  fill?: ApexFill
  labels?: string[]
  dataLabels?: ApexDataLabels
  stroke?: any
  colors?: string[]
}
interface DateRange {
  startDate: dayjs.Dayjs
  endDate: dayjs.Dayjs
}

declare var $: any

@Component({
  selector: 'app-empdashboard',
  imports: [
    ReactiveFormsModule,
    NgIf,
    CommonModule,
    RouterModule,
    // CapitalizePipe,
    FormsModule,
    // HasPermissionDirective,
    HasModuleDirective,
    SharedModule,
    NgApexchartsModule,
    // NgxDaterangepickerBootstrapDirective,
    AttendanceClockComponent,
    HasPermissionDirective
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class EmpDashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  private store = inject(Store)
  private router = inject(Router)
  private destroy$ = new Subject<void>()
  public defaultImg = '../../../../assets/img/user.jpg'
  public imagePath: any
  // public imageURL:  string | null = this.defaultImg
  public imageURL: string | null = ''

  public apiEndpoint = environment.apiBaseUrl
  public attendanceChartOptions!: AttendanceChartOptions
  employeeId = ''
  employee$: Observable<User | undefined> = of(undefined) // Initialize with a default value
  employeeImages: { [key: string]: string } = {} // Ensure this is defined correctly
  user: AuthState['user'] | null = null
  user$: Observable<User | null> = this.store.select(selectUser)
  timeLabels: string[] = []
  public progressData: { start: string; width: string; color: string; rotate?: string }[] = []
  isPunchedIn$: Observable<boolean> = this.store.pipe(select(selectIsPunchedIn))
  isPunchedIn = false
  punchInId = ''
  latestPunchIn$: Observable<ClockInClockOut | null> = this.store.pipe(select(selectLatestPunchIn))
  latestPunchIn!: ClockInClockOut | null
  totalWorkHoursThisMonth = ''
  totalWorkHoursThisWeek = ''
  totalWorkHoursToday = ''
  todaysClockinoutRecords!: ClockInClockOut[]
  totalProductiveWorkHoursToday = ''
  totalBreakHoursToday = ''
  // totalWorkHoursThisMonth$!: Observable<string>
  // totalWorkHoursThisWeek$!: Observable<string>
  totalWorkHoursThisWeek$ = this.store.select(selectTotalWorkHoursThisWeek)
  totalWorkHoursThisMonth$ = this.store.select(selectTotalWorkHoursThisMonth)
  totalWorkHoursToday$ = this.store.select(selectTotalWorkHoursToday)
  todaysClockinoutRecords$ = this.store.select(selectTodaysClockinoutRecords)
  totalProductiveWorkHoursToday$ = this.store.select(selectTotalProductiveWorkHoursToday)
  totalBreakHoursToday$ = this.store.select(selectTotalBreakHoursToday)
  totalOvertimeToday$ = this.store.select(selectTotalOvertimeToday)
  totalOvertimeThisMonth$ = this.store.select(selectTotalOvertimeThisMonth)
  // expectedWorkHoursToday$ = this.store.select(selectExpectedWorkHoursToday)
  // expectedWorkHoursThisWeek$ = this.store.select(selectExpectedWorkHoursThisWeek)
  // expectedWorkHoursThisMonth$ = this.store.select(selectExpectedWorkHoursThisMonth)

  expectedWorkHoursToday$ = this.store.select(selectExpectedWorkHoursToday).pipe(
    map(v => (v === '0h' ? null : v)),
    tap(v => {
      if (v) localStorage.setItem('expectedToday', v)
    }),
    map(v => v ?? localStorage.getItem('expectedToday')),
    filter((v): v is string => !!v),
    distinctUntilChanged(),
    shareReplay(1)
  )
  expectedWorkHoursThisWeek$ = this.store.select(selectExpectedWorkHoursThisWeek).pipe(
    map(v => (v === '0h' ? null : v)),
    tap(v => v && localStorage.setItem('expectedWeek', v)),
    map(v => v ?? localStorage.getItem('expectedWeek')),
    filter((v): v is string => !!v),
    distinctUntilChanged(),
    shareReplay(1)
  )
  expectedWorkHoursThisMonth$ = this.store.select(selectExpectedWorkHoursThisMonth).pipe(
    map(v => (v === '0h' ? null : v)),
    tap(v => v && localStorage.setItem('expectedMonth', v)),
    map(v => v ?? localStorage.getItem('expectedMonth')),
    filter((v): v is string => !!v),
    distinctUntilChanged(),
    shareReplay(1)
  )
  currentDate = new Date()
  private dateSubscription!: Subscription
  private destroyed$ = new Subject<void>()
  teamMembers!: User[]
  teamMembers$!: Observable<User[]>
  birthdayEmployees!: User[]
  birthdayEmployees$!: Observable<User[]>
  notifications: Notification[] = []
  isNotificationsLoading = false
  isChartExpanded = false

  eps = eps //Endponits
  workstatusEnum = WorkStatus
  isLoading$ = this.store.pipe(select(selectLoading))
  nextHoliday: Holiday | null = null
  linkPath: string[] = []
  clockInOutCount$!: Observable<ClockInOutCountResponse>
  queryParams: any = {}
  isBusinessOwner = false
  type = ''
  settling$ = new BehaviorSubject<boolean>(false)

  leaveDateRange: Date[] = []
  dateRange!: DateRange
  form!: FormGroup
  isHalfDay = true
  dateRangeforHalfDay: { date: string; halfDayOption: string; selectionType: string }[] = []

  defaultCount: ClockInOutCountResponse = {
    attendanceDetails: {
      onTime: 0,
      lateAttendance: 0,
      earlyLeave: 0,
      workFromHome: 0,
      absent: 0,
      sickLeave: 0,
      workedDays: 0,
      performance: '0'
    },
    leaveDetails: {
      totalLeaves: 0,
      taken: 0,
      absent: 0,
      request: 0,
      lossOfPay: 0,
      upcomingLeaves: 0
    },
    forceRefresh: false
  }
  attendanceData$ = new BehaviorSubject<ClockInOutCountResponse>(this.defaultCount)
  leaveData$ = new BehaviorSubject<ClockInOutCountResponse>(this.defaultCount)
  progressRotation: string = 'rotate(-90deg)'
  attendancePercent = 0
  maxWorkHours = 9 // 8, 9, 10 as per company rule
  leftRotation = 'rotate(0deg)'
  rightRotation = 'rotate(0deg)'

  chartOptions: Partial<ChartOptions> = {
    series: [],
    chart: {
      type: 'radialBar'
    },
    plotOptions: {},
    fill: {},
    labels: [],
    dataLabels: {}
  }

  @Input() clockInTime!: string // "2026-04-13T09:35:00"
  currentTime = new Date()
  clockPercent = 0
  totalTimeLabel = '0h 0m'
  clockStartAngle = 0

  @Input() workMinutes = 0
  @Input() breakMinutes = 0
  @Input() overtimeMinutes = 0
  @Input() totalShiftMinutes = 480 // e.g. 8 hour shift, adjust as needed

  ringBackground = ''
  segmentsForLegend: { label: string; color: string; value: number }[] = []

  //24 hours clock
  // dayRecords: ClockInClockOut[] = []
  // dayLabels = Array.from({ length: 24 }, (_, i) => i)
  // nowAngle = 0

  private dayRecords: ClockInClockOut[] = []
  ringSegments: {
    color: string
    dasharray: string
    dashoffset: number
  }[] = []

  ringCenter = 65
  ringOuterR = 62
  ringInnerR = 54
  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private toasterNotification: ToastrService,
    private actions$: Actions,
    private userService: UserService,
    private notificationService: NotificationService,
    // private holidayService: HolidayService
    private clockInClockOutService: ClockInClockOutService,
    private cd: ChangeDetectorRef
  ) {
    this.generateTimeLabels()
  }

  // ngOnInit() {
  //   this.store
  //     .select(selectUser)
  //     .pipe(tap(user => (this.user = user)))
  //     .subscribe(user => {
  //       if (user) {
  //         this.store.dispatch(loadEmployeeById({ id: user.id }))
  //         this.loadAttendances()
  //         this.store.dispatch(getLatestClockIn({ id: user.id }))
  //         const params = ''
  //         const page = 1
  //         const limit = 5
  //         this.teamMembers$ = this.userService
  //           .getTeamMembersOfEmployee(this.user?.id ?? '', params, page, limit)
  //           .pipe(map(res => res.teamMembers))
  //         if (user.businessId) {
  //           this.getTeamMemberBirthday(user.businessId)
  //         }
  //         this.getNotifications(user.id)
  //       }
  //       //leave policy for dashbaord
  //       this.store
  //         .select(selectUserPermissions)
  //         .pipe(take(1))
  //         .subscribe(perms => {
  //           const hasLeavePolicyView = perms['leavePolicy']?.includes('view')
  //           if (hasLeavePolicyView) {
  //             this.linkPath = ['/', eps.leaves.base, eps.leaves.policies]
  //           } else {
  //             this.linkPath = ['/', eps.hrm.base, eps.hrm.employee, user?.id]
  //             this.queryParams = { tab: 'leave' }
  //           }
  //         })
  //       //upcoming holiday
  //       this.clockInClockOutService.upcomingHoliday(user?.id ?? '').subscribe(res => {
  //         this.nextHoliday = res ? ({ title: res.title, date: res.date } as Holiday) : null
  //       })
  //       //count
  //       this.clockInOutCount$ = this.clockInClockOutService.getClockInOutCount().pipe(
  //         catchError(() => of(this.defaultCount)),
  //         startWith(this.defaultCount),
  //         shareReplay(1)
  //       )
  //       //hide business owner progress
  //       if (!user) return
  //       this.isBusinessOwner = user.employmentType === 'Business Owner'
  //       //chart
  //       this.initAttendanceChart()
  //       this.bindAttendanceChartData()
  //     })
  //   // this.todaysClockinoutRecords$.subscribe(records => {
  //   //   this.todaysClockinoutRecords = records
  //   //   this.progressData = this.calculateProgressBars(this.todaysClockinoutRecords)
  //   // })
  //   // Recalculate progress every minute
  //   combineLatest([
  //     this.todaysClockinoutRecords$,
  //     this.latestPunchIn$,
  //     interval(60000).pipe(startWith(0))
  //   ])
  //     .pipe(
  //       map(([records, latestPunchIn]) => {
  //         const hasOngoing =
  //           latestPunchIn?.workStatus === this.workstatusEnum.CLOCKIN && !latestPunchIn.clockOut

  //         let combinedRecords = [...records]

  //         if (hasOngoing) {
  //           const existing = records.find(r => r.id === latestPunchIn.id)
  //           if (!existing) {
  //             combinedRecords = [...records, latestPunchIn] // 👈 include ongoing punch-in
  //           }
  //         }

  //         return this.calculateProgressBars(combinedRecords)
  //       })
  //     )
  //     .subscribe(progressData => {
  //       this.progressData = progressData
  //     })

  //   setInterval(() => {
  //     this.currentDate = new Date()
  //   }, 1000)

  //   // Subscribe to the observable and log the value of isPunchedIn
  //   // this.isPunchedIn$.subscribe(isPunchedIn => {
  //   //   this.isPunchedIn = isPunchedIn
  //   //   console.log('isPunchedIn in constructor: ', isPunchedIn)
  //   // })

  //   // this.latestPunchIn$.subscribe(latestPunchIn => {
  //   //   this.latestPunchIn = latestPunchIn
  //   //   console.log('latestPunchIn in constructor: ', latestPunchIn?.clockIn)
  //   //   if (this.latestPunchIn) {
  //   //     this.latestPunchIn.clockIn = new Date(this.latestPunchIn.clockIn)
  //   //   }
  //   // })
  //   // this.latestPunchIn$.subscribe(latestPunchIn => {
  //   //   console.log('latestPunchIn in constructor: ', latestPunchIn?.clockIn)

  //   //   if (latestPunchIn) {
  //   //     this.latestPunchIn = {
  //   //       ...latestPunchIn,
  //   //       clockIn: new Date(latestPunchIn.clockIn)
  //   //     }
  //   //   }
  //   // })

  //   this.actions$
  //     .pipe(
  //       ofType(
  //         createClockInClockOutSuccess,
  //         createClockInClockOutFailure,
  //         updateClockInSuccess,
  //         updateClockInFailure
  //       ),
  //       takeUntil(this.destroyed$) // don't forget to clean up
  //     )
  //     .subscribe(() => {
  //       if (this.user) {
  //         this.store.dispatch(loadEmployeeById({ id: this.user?.id }))
  //         this.loadAttendances()
  //         this.store.dispatch(getLatestClockIn({ id: this.user?.id }))
  //       }
  //     })

  //   // this.getTeamMembersOfEmployee()
  // }

  // optimized gps 12 march 2026
  // ngOnInit() {
  //   this.store
  //     .select(selectUser)
  //     .pipe(
  //       filter(user => !!user),
  //       take(1),
  //       tap(user => (this.user = user)),
  //       mergeMap(user => {
  //         // dispatch actions only once
  //         this.store.dispatch(loadEmployeeById({ id: user.id }))
  //         this.store.dispatch(getLatestClockIn({ id: user.id }))
  //         this.loadAttendances()

  //         // parallel API calls
  //         return forkJoin({
  //           teamMembers: this.userService
  //             .getTeamMembersOfEmployee(user.id, '', 1, 5)
  //             .pipe(map(r => r.teamMembers)),

  //           notifications: this.getNotifications(user.id),

  //           nextHoliday: this.clockInClockOutService.upcomingHoliday(user.id).pipe(
  //             map(res => (res ? { id: res.id, title: res.title, date: res.date } : null)),
  //             catchError(() => of(null)),
  //             shareReplay(1)
  //           ),

  //           count: this.clockInClockOutService.getClockInOutCount().pipe(
  //             startWith(this.defaultCount),
  //             catchError(() => of(this.defaultCount)),
  //             shareReplay(1)
  //           )
  //         })
  //       })
  //     )
  //     .subscribe(result => {
  //       this.teamMembers$ = of(result.teamMembers)
  //       this.nextHoliday = result.nextHoliday
  //       this.clockInOutCount$ = of(result.count)
  //       this.notifications = result.notifications
  //       // Business owner
  //       this.isBusinessOwner = this.user?.employmentType === 'Business Owner'

  //       // Leave policy permission check
  //       this.store
  //         .select(selectUserPermissions)
  //         .pipe(take(1))
  //         .subscribe(perms => {
  //           if (perms['leavePolicy']?.includes('view')) {
  //             this.linkPath = ['/', eps.leaves.base, eps.leaves.policies]
  //           } else {
  //             this.linkPath = ['/', eps.hrm.base, eps.hrm.employee, this.user?.id]
  //             this.queryParams = { tab: 'leave' }
  //           }
  //         })

  //       // Attendance Chart Init
  //       this.initAttendanceChart()
  //       this.bindAttendanceChartData()
  //     })
  // }

  // ngOnInit() {
  //   this.store
  //     .select(selectUser)
  //     .pipe(
  //       filter(user => !!user),
  //       take(1),
  //       tap(user => (this.user = user))
  //     )
  //     .subscribe(user => {
  //       // FIRE STORE ACTIONS (non-blocking)
  //       this.store.dispatch(loadEmployeeById({ id: user.id }))
  //       this.store.dispatch(getLatestClockIn({ id: user.id }))
  //       this.loadAttendances()

  //       // setTimeout(() => this.loadAttendances(), 500)
  //       // setTimeout(() => this.store.dispatch(getLatestClockIn({ id: user.id })), 1000)

  //       // ================================
  //       // TEAM MEMBERS (updates instantly)
  //       // ================================
  //       this.userService
  //         .getTeamMembersOfEmployee(user.id, '', 1, 5)
  //         .pipe(map(r => r.teamMembers))
  //         .subscribe(data => {
  //           this.teamMembers$ = of(data)
  //         })

  //       // ================================
  //       // NOTIFICATIONS (updates instantly)
  //       // ================================
  //       this.getNotifications(user.id).subscribe(res => {
  //         this.notifications = res
  //       })

  //       // ================================
  //       // NEXT HOLIDAY (updates instantly)
  //       // ================================
  //       this.clockInClockOutService
  //         .upcomingHoliday(user.id)
  //         .pipe(
  //           map(res => (res ? { id: res.id, title: res.title, date: res.date } : null)),
  //           catchError(() => of(null))
  //         )
  //         .subscribe(res => {
  //           this.nextHoliday = res
  //         })

  //       // ================================
  //       // CLOCK IN / OUT COUNT (no timeout)
  //       // ================================
  //       this.type = 'self'
  //       this.clockInOutCount$ = this.clockInClockOutService.getClockInOutCount(thistype).pipe(
  //         startWith(this.defaultCount),
  //         catchError(() => of(this.defaultCount)),
  //         shareReplay(1)
  //       )

  //       // ================================
  //       // BUSINESS OWNER FLAG
  //       // ================================
  //       this.isBusinessOwner = user.employmentType === 'Business Owner'

  //       // ================================
  //       // PERMISSION BASED NAVIGATION
  //       // ================================
  //       this.store
  //         .select(selectUserPermissions)
  //         .pipe(take(1))
  //         .subscribe(perms => {
  //           const hasLeave = perms['leavePolicy']?.includes('view')
  //           this.linkPath = hasLeave
  //             ? ['/', eps.leaves.base, eps.leaves.policies]
  //             : ['/', eps.hrm.base, eps.hrm.employee, user.id]
  //           this.queryParams = hasLeave ? {} : { tab: 'leave' }
  //         })

  //       // ================================
  //       // CHART INIT (non-blocking)
  //       // ================================
  //       this.initAttendanceChart()
  //       this.bindAttendanceChartData()
  //     })
  // }

  //optimized 13 march 2026 gps evening
  // ngOnInit() {
  //   this.store
  //     .select(selectUser)
  //     .pipe(
  //       distinctUntilChanged((a, b) => a?.id === b?.id),
  //       takeUntil(this.destroy$)
  //     )
  //     .subscribe(user => {
  //       if (!user) return

  //       // 1️⃣ Load basic lightweight details first
  //       this.store.dispatch(loadEmployeeById({ id: user.id }))
  //       // this.isNotificationsLoading = true
  //       // this.getNotifications(user.id).subscribe(res => {
  //       //   this.notifications = res
  //       // })

  //       // 2️⃣ Stagger heavy API calls to avoid parallel load
  //       setTimeout(() => {
  //         this.store.dispatch(getLatestClockIn({ id: user.id }))
  //       }, 200)

  //       // setTimeout(() => {
  //       //   this.clockInClockOutService
  //       //     .upcomingHoliday(user.id)
  //       //     .subscribe(res => (this.nextHoliday = res || null))
  //       // }, 400)
  //       timer(400)
  //         .pipe(
  //           switchMap(() => this.clockInClockOutService.upcomingHoliday(user.id)),
  //           takeUntil(this.destroy$)
  //         )
  //         .subscribe(res => (this.nextHoliday = res || null))

  //       setTimeout(() => {
  //         this.teamMembers$ = this.userService
  //           .getTeamMembersOfEmployee(user.id, '', 1, 5)
  //           .pipe(map(res => res.teamMembers))
  //       }, 600)

  //       setTimeout(() => {
  //         this.getTeamMemberBirthday(user.businessId)
  //       }, 800)

  //       setTimeout(() => {
  //         this.getNotifications(user.id)
  //       }, 1000)

  //       // // 3️⃣ LOAD ATTENDANCE LAST (MOST HEAVY)
  //       setTimeout(() => {
  //         this.loadAttendances()
  //       }, 1200)

  //       // 4️⃣ Lightweight counter
  //       this.type = 'self'
  //       this.clockInOutCount$ = this.clockInClockOutService.getClockInOutCount(this.type).pipe(
  //         catchError(() => of(this.defaultCount)),
  //         startWith(this.defaultCount),
  //         shareReplay(1)
  //       )

  //       // 5️⃣ Leave policies
  //       setTimeout(() => {
  //         this.store
  //           .select(selectUserPermissions)
  //           .pipe(take(1))
  //           .subscribe(perms => {
  //             const hasView = perms['leavePolicy']?.includes('view')
  //             if (hasView) {
  //               this.linkPath = ['/', eps.leaves.base, eps.leaves.policies]
  //             } else {
  //               this.linkPath = ['/', eps.hrm.base, eps.hrm.employee, user.id]
  //               this.queryParams = { tab: 'leave' }
  //             }
  //           })
  //       }, 1500)

  //       // 6️⃣ Chart init AFTER attendance loaded
  //       setTimeout(() => {
  //         this.initAttendanceChart()
  //         this.bindAttendanceChartData()
  //       }, 1800)
  //     })

  //   // 7️⃣ Progress calculation loop
  //   combineLatest([
  //     this.todaysClockinoutRecords$,
  //     this.latestPunchIn$,
  //     interval(60000).pipe(startWith(0))
  //   ])
  //     .pipe(
  //       map(([records, latestPunchIn]) => {
  //         const ongoing =
  //           latestPunchIn?.workStatus === this.workstatusEnum.CLOCKIN && !latestPunchIn.clockOut

  //         const combined = [...records]
  //         if (ongoing && !records.find(r => r.id === latestPunchIn.id)) {
  //           combined.push(latestPunchIn)
  //         }

  //         return this.calculateProgressBars(combined)
  //       })
  //     )
  //     .subscribe(p => (this.progressData = p))

  //   // 8️⃣ Date every second
  //   // setInterval(() => (this.currentDate = new Date()), 1000)
  //   interval(1000)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(() => (this.currentDate = new Date()))

  //   // 9️⃣ After punch in/out updates
  //   this.actions$
  //     .pipe(
  //       ofType(
  //         createClockInClockOutSuccess,
  //         createClockInClockOutFailure,
  //         updateClockInSuccess,
  //         updateClockInFailure
  //       ),
  //       takeUntil(this.destroy$)
  //     )
  //     .subscribe(() => {
  //       setTimeout(() => {
  //         this.store.dispatch(loadEmployeeById({ id: this.user?.id ?? '' }))
  //         this.store.dispatch(getLatestClockIn({ id: this.user?.id ?? '' }))
  //       }, 300)

  //       setTimeout(() => this.loadAttendances(), 600)
  //     })
  // }

  //optimized 19 march 2026 gps
  ngOnInit() {
    this.form = this.fb.group({
      fromDate: [''],
      toDate: [''],
      attendanceRange: [''],
      leaveRange: ['']
    })
    // Update currentDate every 1 second
    this.dateSubscription = interval(1000).subscribe(() => {
      this.currentDate = new Date()
    })
    const user$ = this.store.select(selectUser).pipe(
      distinctUntilChanged((a, b) => a?.id === b?.id),
      takeUntil(this.destroy$)
    )

    user$
      .pipe(
        filter(user => !!user),

        tap(user => {
          this.user = user
          this.store.dispatch(loadEmployeeById({ id: user.id }))
          // Subscribe to notifications
          // this.getNotifications(user.id).subscribe(res => {
          //   this.notifications = res
          // })
          // lightweight immediate call
          this.type = 'self'
          // this.clockInOutCount$ = this.clockInClockOutService.getClockInOutCount(this.type).pipe(
          //   catchError(() => of(this.defaultCount)),
          //   startWith(this.defaultCount),
          //   shareReplay(1)
          // )
          // this.linkPath = ['/', eps.hrm.base, eps.hrm.employee, user.id]
          // this.queryParams = { tab: 'leave' }
          // this.store
          //   .select(selectUserPermissions)
          //   .pipe(take(1))
          //   .subscribe(perms => {
          //     const hasLeavePolicyView = perms['leavePolicy']?.includes('view')
          //     if (hasLeavePolicyView) {
          //       this.linkPath = ['/', eps.leaves.base, eps.leaves.policies]
          //       this.queryParams = {}
          //     } else {
          //       this.linkPath = ['/', eps.hrm.base, eps.hrm.employee, user.id]
          //       this.queryParams = { tab: 'leave' }
          //     }
          //   })
          // this.store
          //   .select(selectUserPermissions)
          //   .pipe(
          //     filter(perms => !!perms && Object.keys(perms).length > 0),
          //     take(1)
          //   )
          //   .subscribe(perms => {
          //     const hasLeavePolicyView = perms['leavePolicy']?.includes('view')
          //     if (hasLeavePolicyView) {
          //       this.linkPath = ['/', eps.leaves.base, eps.leaves.policies]
          //       this.queryParams = {}
          //     } else {
          //       this.linkPath = ['/', eps.hrm.base, eps.hrm.employee, user.id]
          //       this.queryParams = { tab: 'leave' }
          //     }
          //   })
          if (user.employmentType === 'Business Owner') {
            this.linkPath = ['/', eps.leaves.base, eps.leaves.policies]
            this.queryParams = {}
          } else {
            this.linkPath = ['/', eps.hrm.base, eps.hrm.employee, user.id]
            this.queryParams = { tab: 'leave' }
          }
          this.loadAttendanceData()
          this.loadLeaveData()
        }),

        tap(() => this.loadAttendances()),

        tap(user => {
          this.teamMembers$ = this.userService.getTeamMembersOfEmployee(user.id, '', 1, 5).pipe(
            map(res => res.teamMembers),
            shareReplay(1)
          )
        }),

        switchMap(user =>
          concat(
            // 1️⃣ Latest clock-in (after 200ms)
            timer(200).pipe(tap(() => this.store.dispatch(getLatestClockIn({ id: user.id })))),

            // 2️⃣ Upcoming holiday
            timer(400).pipe(
              switchMap(() => this.clockInClockOutService.upcomingHoliday(user.id)),
              tap(res => (this.nextHoliday = res || null))
            ),

            // 3️⃣ Team members
            // timer(600).pipe(
            //   tap(() => {
            //     this.teamMembers$ = this.userService
            //       .getTeamMembersOfEmployee(user.id, '', 1, 5)
            //       .pipe(map(res => res.teamMembers))
            //   })
            // ),

            // 4️⃣ Birthdays
            timer(800).pipe(tap(() => this.getTeamMemberBirthday(user.businessId))),

            // 5️⃣ Notifications
            // timer(1000).pipe(tap(() => this.getNotifications(user.id))),
            timer(1000).pipe(
              switchMap(() => this.getNotifications(user.id)),
              tap(res => (this.notifications = res))
            ),

            // 6️⃣ Attendance (heaviest)
            // timer(1200).pipe(tap(() => this.loadAttendances())),

            // 7️⃣ Leave permissions
            // timer(1500).pipe(
            //   switchMap(() => this.store.select(selectUserPermissions).pipe(take(1))),
            //   tap(perms => {
            //     const hasView = perms['leavePolicy']?.includes('view')
            //     if (hasView) {
            //       this.linkPath = ['/', eps.leaves.base, eps.leaves.policies]
            //     } else {
            //       this.linkPath = ['/', eps.hrm.base, eps.hrm.employee, user.id]
            //       this.queryParams = { tab: 'leave' }
            //     }
            //   })
            // ),

            // 8️⃣ Charts
            timer(1800).pipe(
              tap(() => {
                this.initAttendanceChart()
                this.bindAttendanceChartData()
              })
            )
          )
        ),

        takeUntil(this.destroy$)
      )
      .subscribe()

    combineLatest([
      this.todaysClockinoutRecords$,
      this.latestPunchIn$,
      interval(60000).pipe(startWith(0))
    ])
      .pipe(
        takeUntil(this.destroy$),
        map(([records, latestPunchIn]) => {
          const today = new Date().toDateString()
          const filteredRecords = (records || []).filter(
            r => new Date(r.clockIn).toDateString() === today
          )
          const combined = [...filteredRecords]
          const ongoing =
            latestPunchIn?.workStatus === this.workstatusEnum.CLOCKIN && !latestPunchIn.clockOut

          // const combined = [...records]
          // if (ongoing && !records.find(r => r.id === latestPunchIn.id)) {
          //   combined.push(latestPunchIn)
          // }
          if (ongoing && latestPunchIn && !filteredRecords.find(r => r.id === latestPunchIn.id)) {
            combined.push(latestPunchIn)
          }
          // this.updateClock()
          // return this.calculateProgressBars(combined)
          // const progress = this.calculateProgressBars(combined)

          // return progress

          //24 hours ring
          const progress = this.calculateProgressBars(combined)
          this.dayRecords = combined
          // this.buildDayGradient()
          this.buildGradient()
          return progress
        })
      )
      // .subscribe(p => (this.progressData = p))
      .subscribe(progress => {
        // this.progressData = progress
        // this.updateClockFromProgress(progress)
        this.progressData = [...progress]
        this.updateClockFromProgress(progress)
        this.cd.detectChanges()
        // this.updateCircle(this.attendancePercent)
      })

    this.actions$
      .pipe(
        ofType(
          createClockInClockOutSuccess,
          createClockInClockOutFailure,
          updateClockInSuccess,
          updateClockInFailure
        ),
        switchMap(() =>
          concat(
            timer(300).pipe(
              tap(() => {
                this.store.dispatch(loadEmployeeById({ id: this.user?.id ?? '' }))
                this.store.dispatch(getLatestClockIn({ id: this.user?.id ?? '' }))
              })
            ),
            // timer(600).pipe(tap(() => this.loadAttendances()))
            timer(600).pipe(
              tap(() => this.loadAttendances()),
              switchMap(() => this.actions$.pipe(ofType(loadEmployeeAttendanceSuccess), take(1))),
              tap(() => this.settling$.next(false))
            )
          )
        ),
        takeUntil(this.destroy$)
      )
      .subscribe()

    const totalClockData = this.progressData.length
    const angleStep = 360 / totalClockData

    // this.progressData = this.progressData.map((item, i) => ({
    //   ...item,
    //   rotate: `rotate(${i * angleStep - 90}deg)`
    // }))
    // this.generateProgress()
    // this.updateCircle(this.attendancePercent)

    // this.updateClock()
    // setInterval(() => {
    //   this.currentTime = new Date()
    //   this.updateClock()
    // }, 60000) // update every 1 min

    // this.buildGradient()
    // combineLatest([
    //   this.totalWorkHoursIncludingCurrent$,
    //   this.totalBreakHoursToday$,
    //   this.totalOvertimeToday$
    // ])
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(([work, brk, ot]) => {
    //     this.workMinutes = this.parseTimeToMinutes(work)
    //     this.breakMinutes = this.parseTimeToMinutes(brk)
    //     this.overtimeMinutes = this.parseTimeToMinutes(ot)
    //     this.totalShiftMinutes = this.maxWorkHours * 60 // 9h = 540
    //     this.buildGradient()
    //     this.cd.detectChanges()
    //   })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
    // Prevent memory leaks by unsubscribing
    if (this.dateSubscription) {
      this.dateSubscription.unsubscribe()
    }
  }

  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     const minDate = this.user?.joiningDate
  //       ? new Date(this.user.joiningDate)
  //       : new Date(new Date().getFullYear(), 0, 1)
  //     // ADD: Get current month start & end
  //     const startOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  //     const endOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
  //     // Ensure start date is not before joining date
  //     const adjustedStartDate = startOfMonth < minDate ? minDate : startOfMonth

  //     // FORMAT FUNCTION (NO moment/dayjs)
  //     const formatDate = (date: Date) => {
  //       const d = ('0' + date.getDate()).slice(-2)
  //       const m = ('0' + (date.getMonth() + 1)).slice(-2)
  //       const y = date.getFullYear()
  //       return `${d}/${m}/${y}`
  //     }
  //     const formatApiDate = (date: Date) => {
  //       const d = ('0' + date.getDate()).slice(-2)
  //       const m = ('0' + (date.getMonth() + 1)).slice(-2)
  //       const y = date.getFullYear()
  //       return `${y}-${m}-${d}`
  //     }
  //     // // DEFAULT FORMATTED VALUE (UI)
  //     // const defaultFormatted = formatDate(startOfMonth) + ' - ' + formatDate(endOfMonth)
  //     // // DEFAULT API VALUES
  //     // const defaultFromDate = formatApiDate(startOfMonth)
  //     // const defaultToDate = formatApiDate(endOfMonth)

  //     // Use adjustedStartDate instead of startOfMonth
  //     const defaultFormatted = formatDate(adjustedStartDate) + ' - ' + formatDate(endOfMonth)

  //     // Use adjustedStartDate
  //     const defaultFromDate = formatApiDate(adjustedStartDate)
  //     const defaultToDate = formatApiDate(endOfMonth)

  //     // Attendance Date Range
  //     $('#attendanceDateRange').daterangepicker({
  //       autoUpdateInput: false,
  //       minDate: minDate,
  //       startDate: adjustedStartDate,
  //       endDate: endOfMonth,
  //       showCancel: false,
  //       locale: {
  //         format: 'DD/MM/YYYY'
  //       }
  //     })
  //     // SET DEFAULT VALUE IN INPUT FIELD
  //     $('#attendanceDateRange').val(defaultFormatted)
  //     // SET DEFAULT FORM VALUES
  //     this.form.patchValue({
  //       attendanceRange: defaultFormatted,
  //       fromDate: defaultFromDate,
  //       toDate: defaultToDate
  //     })
  //     // CALL API WITH DEFAULT MONTH
  //     // this.loadDashboardData(defaultFromDate, defaultToDate)
  //     this.loadAttendanceData(defaultFromDate, defaultToDate)
  //     this.loadLeaveData(defaultFromDate, defaultToDate)
  //     // APPLY
  //     $('#attendanceDateRange').on('apply.daterangepicker', (ev: any, picker: any) => {
  //       const formatted =
  //         picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY')
  //       $('#attendanceDateRange').val(formatted)
  //       const fromDate = picker.startDate.format('YYYY-MM-DD')
  //       const toDate = picker.endDate.format('YYYY-MM-DD')
  //       this.form.patchValue({
  //         attendanceRange: formatted,
  //         fromDate,
  //         toDate
  //       })
  //       this.loadAttendanceData(fromDate, toDate)
  //     })

  //     // Leave Date Range
  //     $('#leaveDateRange').daterangepicker({
  //       autoUpdateInput: false,
  //       minDate: minDate,
  //       startDate: adjustedStartDate,
  //       endDate: endOfMonth,
  //       showCancel: false,
  //       locale: {
  //         format: 'DD/MM/YYYY'
  //       }
  //     })
  //     $('#leaveDateRange').val(defaultFormatted)
  //     $('#leaveDateRange').on('apply.daterangepicker', (ev: any, picker: any) => {
  //       const formatted =
  //         picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY')
  //       $('#leaveDateRange').val(formatted)
  //       const fromDate = picker.startDate.format('YYYY-MM-DD')
  //       const toDate = picker.endDate.format('YYYY-MM-DD')
  //       this.form.patchValue({
  //         leaveRange: formatted
  //       })
  //       this.loadLeaveData(fromDate, toDate)
  //     })
  //   }, 100)
  // }

  ngAfterViewInit() {
    // this.waitForElementAndInit('attendanceDateRange', () => this.setupDateRangePickers())
    this.store
      .select(selectUser)
      .pipe(
        filter(user => !!user),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.waitForElementAndInit('attendanceDateRange', () => this.setupDateRangePickers())
      })
  }

  private waitForElementAndInit(
    elementId: string,
    callback: () => void,
    maxAttempts = 20,
    interval = 150
  ) {
    let attempts = 0

    const check = setInterval(() => {
      attempts++
      const el = document.getElementById(elementId)

      if (el) {
        clearInterval(check)
        callback()
      } else if (attempts >= maxAttempts) {
        clearInterval(check) // stop after ~3 seconds
      }
    }, interval)
  }

  private setupDateRangePickers() {
    const minDate = this.user?.joiningDate
      ? new Date(this.user.joiningDate)
      : new Date(new Date().getFullYear(), 0, 1)

    const startOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    const endOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
    const adjustedStartDate = startOfMonth < minDate ? minDate : startOfMonth

    const formatDate = (date: Date) => {
      const d = ('0' + date.getDate()).slice(-2)
      const m = ('0' + (date.getMonth() + 1)).slice(-2)
      const y = date.getFullYear()
      return `${d}/${m}/${y}`
    }

    const formatApiDate = (date: Date) => {
      const d = ('0' + date.getDate()).slice(-2)
      const m = ('0' + (date.getMonth() + 1)).slice(-2)
      const y = date.getFullYear()
      return `${y}-${m}-${d}`
    }

    const defaultFormatted = formatDate(adjustedStartDate) + ' - ' + formatDate(endOfMonth)
    const defaultFromDate = formatApiDate(adjustedStartDate)
    const defaultToDate = formatApiDate(endOfMonth)

    // ── Attendance Date Range ──────────────────────────────
    $('#attendanceDateRange').daterangepicker({
      autoUpdateInput: false,
      minDate: minDate,
      startDate: adjustedStartDate,
      endDate: endOfMonth,
      showCancel: false,
      locale: { format: 'DD/MM/YYYY' }
    })
    $('#attendanceDateRange').val(defaultFormatted)

    this.form.patchValue({
      attendanceRange: defaultFormatted,
      fromDate: defaultFromDate,
      toDate: defaultToDate
    })

    // this.loadAttendanceData(defaultFromDate, defaultToDate)
    // this.loadLeaveData(defaultFromDate, defaultToDate)

    $('#attendanceDateRange').on('apply.daterangepicker', (ev: any, picker: any) => {
      const formatted =
        picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY')
      $('#attendanceDateRange').val(formatted)
      const fromDate = picker.startDate.format('YYYY-MM-DD')
      const toDate = picker.endDate.format('YYYY-MM-DD')
      this.form.patchValue({ attendanceRange: formatted, fromDate, toDate })
      this.loadAttendanceData(fromDate, toDate)
    })

    // ── Leave Date Range ───────────────────────────────────
    const leaveEl = document.getElementById('leaveDateRange')
    if (leaveEl) {
      $('#leaveDateRange').daterangepicker({
        autoUpdateInput: false,
        minDate: minDate,
        startDate: adjustedStartDate,
        endDate: endOfMonth,
        showCancel: false,
        locale: { format: 'DD/MM/YYYY' }
      })
      $('#leaveDateRange').val(defaultFormatted)

      $('#leaveDateRange').on('apply.daterangepicker', (ev: any, picker: any) => {
        const formatted =
          picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY')
        $('#leaveDateRange').val(formatted)
        const fromDate = picker.startDate.format('YYYY-MM-DD')
        const toDate = picker.endDate.format('YYYY-MM-DD')
        this.form.patchValue({ leaveRange: formatted })
        this.loadLeaveData(fromDate, toDate)
      })
    }
  }

  generateDateRange() {
    const fromDate = new Date(this.form.get('fromDate')?.value)
    const toDate = new Date(this.form.get('toDate')?.value)

    if (fromDate && toDate && fromDate <= toDate) {
      // Ensure valid date range
      const tempDate = new Date(fromDate)
      this.dateRangeforHalfDay = [] // Reset before updating
      // tempDate.setDate(tempDate.getDate() + 1)
      tempDate.setDate(tempDate.getDate())
      const tempToDate = new Date(toDate)
      // tempToDate.setDate(tempToDate.getDate() + 1)
      tempToDate.setDate(tempToDate.getDate())

      while (tempDate <= tempToDate) {
        this.dateRangeforHalfDay.push({
          date: tempDate.toISOString().split('T')[0],
          selectionType: 'FullDay', // Default to FullDay
          halfDayOption: '' // Default value
        })
        tempDate.setDate(tempDate.getDate() + 1)
        // tempDate.setDate(tempDate.getDate())
      }
    }
  }

  loadAttendanceData(fromDate?: string, toDate?: string) {
    this.clockInClockOutService
      .getClockInOutCount(this.type, fromDate, toDate)
      .pipe(catchError(() => of(this.defaultCount)))
      .subscribe(data => this.attendanceData$.next(data))
  }

  loadLeaveData(fromDate?: string, toDate?: string) {
    this.clockInClockOutService
      .getClockInOutCount(this.type, fromDate, toDate)
      .pipe(catchError(() => of(this.defaultCount)))
      .subscribe(data => this.leaveData$.next(data))
  }

  generateTimeLabels() {
    this.timeLabels = Array.from({ length: 25 }, (_, i) => `${i.toString().padStart(2, '0')}:00`)
  }

  punchIn(): void {
    this.settling$.next(true)
    this.store.dispatch(createClockInClockOut({ clockIn: new Date() }))
    if (this.user) {
      this.store.dispatch(
        loadEmployeeAttendance({
          id: this.user.id,
          // params: `userId=${this.user.id}`
          params: null
        })
      )
      this.store.dispatch(getLatestClockIn({ id: this.user.id }))
    }
  }

  punchOut() {
    this.latestPunchIn$
      .pipe(
        filter(latestPunchIn => latestPunchIn !== null),
        take(1)
      )
      .subscribe(latestPunchIn => {
        this.settling$.next(true)
        this.store.dispatch(updateClockIn({ id: latestPunchIn.id }))
      })
  }

  liveToday$ = this.createLiveTimer(this.totalWorkHoursToday$)
  // liveWeek$ = this.createLiveTimer(this.totalWorkHoursThisWeek$)
  // liveMonth$ = this.createLiveTimer(this.totalWorkHoursThisMonth$)
  liveWeek$ = this.createLiveTimerWithBreak(this.totalWorkHoursThisWeek$)
  liveMonth$ = this.createLiveTimerWithBreak(this.totalWorkHoursThisMonth$)
  // totalWithBreakToday$ = combineLatest([this.liveToday$, this.totalBreakHoursToday$]).pipe(
  //   map(([work, breakTime]) => {
  //     const workMinutes = this.parseTimeToMinutes(work)
  //     const breakMinutes = this.parseTimeToMinutes(breakTime)

  //     // return this.formatMinutes(workMinutes + breakMinutes)
  //     return this.formatMinutes(workMinutes)
  //   })
  // )
  // totalWithBreakToday$ = combineLatest([
  //   this.store.select(selectTotalWorkHoursToday),
  //   this.store.select(selectTotalBreakHoursToday)
  // ]).pipe(
  //   map(([work, breakTime]) => {
  //     const workMatch = /(?:(\d+)h)?\s*(?:(\d+)m)?/.exec(work ?? '')
  //     const breakMatch = /(?:(\d+)h)?\s*(?:(\d+)m)?/.exec(breakTime ?? '')

  //     const workMinutes =
  //       parseInt(workMatch?.[1] || '0', 10) * 60 + parseInt(workMatch?.[2] || '0', 10)

  //     const breakMinutes =
  //       parseInt(breakMatch?.[1] || '0', 10) * 60 + parseInt(breakMatch?.[2] || '0', 10)

  //     const totalMinutes = workMinutes + breakMinutes
  //     const hours = Math.floor(totalMinutes / 60)
  //     const minutes = totalMinutes % 60

  //     return `${hours}h ${minutes}m`
  //   }),
  //   shareReplay(1)
  // )
  totalWithBreakToday$ = combineLatest([
    this.store.select(selectTotalWorkHoursToday),
    this.store.select(selectTotalBreakHoursToday),
    this.latestPunchIn$
  ]).pipe(
    map(([work, breakTime, latestPunchIn]) => {
      const workMinutes = this.parseTimeToMinutes(work)
      const breakMinutes = this.parseTimeToMinutes(breakTime)

      let totalMinutes = workMinutes + breakMinutes

      if (
        latestPunchIn?.clockIn &&
        latestPunchIn.workStatus === this.workstatusEnum.CLOCKIN &&
        !latestPunchIn.clockOut
      ) {
        const diffMinutes = Math.floor(
          (Date.now() - new Date(latestPunchIn.clockIn).getTime()) / 60000
        )
        if (diffMinutes > 0) totalMinutes += diffMinutes
      }

      return this.formatMinutes(totalMinutes)
    }),
    shareReplay(1)
  )
  private parseTimeToMinutes(time: string | null): number {
    const match = /(?:(\d+)h)?\s*(?:(\d+)m)?/.exec(time ?? '')
    const hours = match ? parseInt(match[1] || '0', 10) : 0
    const minutes = match ? parseInt(match[2] || '0', 10) : 0
    return hours * 60 + minutes
  }
  private formatMinutes(totalMinutes: number): string {
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60
    return `${hours}h ${minutes}m`
  }

  // calculateProgressBars(records: ClockInClockOut[] = []): {
  //   start: string
  //   width: string
  //   color: string
  // }[] {
  //   const progressData: { start: string; width: string; color: string }[] = []

  //   if (!Array.isArray(records) || records.length === 0) {
  //     return progressData
  //   }

  //   // const workingStartIST = 6 * 60 // 6:00 AM IST
  //   // const workingEndIST = 18 * 60 // 6:00 PM IST
  //   const workingStartIST = 0 // 6:00 AM IST
  //   const workingEndIST = 24 * 60 // 6:00 PM IST
  //   // const totalMinutes = workingEndIST - workingStartIST // 720 minutes
  //   const totalMinutes = 1440

  //   // const getMinutesSinceStart = (time: string | Date | null | undefined): number => {
  //   //   if (!time) return 0
  //   //   const date = typeof time === 'string' ? new Date(time) : time
  //   //   return date.getHours() * 60 + date.getMinutes() - workingStartIST
  //   // }

  //   const toIST = (date: Date): Date => {
  //     // Create a new date object shifted by +5:30
  //     return new Date(date.getTime())
  //     // return new Date(date.getTime() + 60 * 60 * 1000)
  //   }

  //   const getMinutesSinceStart = (time: string | Date | null | undefined): number => {
  //     if (!time) return 0
  //     const utcDate = typeof time === 'string' ? new Date(time) : time
  //     const istDate = toIST(utcDate)
  //     // console.log('ist date', istDate)
  //     return istDate.getHours() * 60 + istDate.getMinutes() - workingStartIST
  //   }
  //   // Sort records by clock-in time
  //   // const sortedRecords = [...records].sort(
  //   //   (a, b) => new Date(a.clockIn).getTime() - new Date(b.clockIn).getTime()
  //   // )

  //   // Add "missing time" before first clock-in
  //   const firstIn = records[0].clockIn
  //   const firstInMinutes = getMinutesSinceStart(firstIn)
  //   if (firstInMinutes > 0) {
  //     // console.log('first in minutes', firstInMinutes)
  //     progressData.push({
  //       start: '0%',
  //       width: `${(firstInMinutes / totalMinutes) * 100}%`,
  //       color: 'bg-transparent' // or a light grey placeholder
  //     })
  //   }

  //   for (const record of records) {
  //     const inMinutes = getMinutesSinceStart(record.clockIn)
  //     const outMinutes = getMinutesSinceStart(record.clockOut)

  //     const startPercentage = Math.max(0, (inMinutes / totalMinutes) * 100)
  //     const endPercentage = Math.min(100, (outMinutes / totalMinutes) * 100)
  //     const width = Math.max(0, endPercentage - startPercentage)

  //     progressData.push({
  //       start: `${startPercentage.toFixed(2)}%`,
  //       width: `${width.toFixed(2)}%`,
  //       color: this.getWorkStatusColor(record.workStatus)
  //     })
  //   }

  //   return progressData
  // }

  calculateProgressBars(records: ClockInClockOut[] = []): {
    start: string
    width: string
    color: string
  }[] {
    const totalMinutes = 1440 // 24 * 60
    const progressData: { start: string; width: string; color: string }[] = []

    // const getMinutes = (time: Date | string): number => {
    //   const date = new Date(time)
    //   return date.getHours() * 60 + date.getMinutes()
    // }

    const getMinutes = (time: Date | string | null | undefined): number => {
      if (!time) return 0
      const date = time instanceof Date ? time : new Date(time)
      return date.getHours() * 60 + date.getMinutes()
    }

    const sorted = [...records].sort(
      (a, b) => new Date(a.clockIn).getTime() - new Date(b.clockIn).getTime()
    )

    const first = sorted[0]?.clockIn
    const firstMinutes = getMinutes(first)
    if (firstMinutes > 0) {
      progressData.push({
        start: '0%',
        width: `${(firstMinutes / totalMinutes) * 100}%`,
        color: 'bg-transparent'
      })
    }

    // for (const record of sorted) {
    //   const inMinutes = getMinutes(record.clockIn)
    //   const outMinutes = record.clockOut ? getMinutes(record.clockOut) : getMinutes(new Date()) // ⏱ use now if not clocked out

    //   const startPct = Math.max(0, (inMinutes / totalMinutes) * 100)
    //   const endPct = Math.min(100, (outMinutes / totalMinutes) * 100)
    //   const width = Math.max(0, endPct - startPct)

    //   progressData.push({
    //     start: `${startPct.toFixed(2)}%`,
    //     width: `${width.toFixed(2)}%`,
    //     color: this.getWorkStatusColor(record.workStatus || this.workstatusEnum.CLOCKIN)
    //   })
    // }

    for (const record of sorted) {
      const inMinutes = getMinutes(record.clockIn)
      const outMinutes = record.clockOut ? getMinutes(record.clockOut) : getMinutes(new Date())

      const startPct = Math.max(0, (inMinutes / totalMinutes) * 100)
      const endPct = Math.min(100, (outMinutes / totalMinutes) * 100)
      const width = Math.max(0, endPct - startPct)

      progressData.push({
        start: `${startPct.toFixed(2)}%`,
        width: `${width.toFixed(2)}%`,
        color: this.getWorkStatusColor(record.workStatus || this.workstatusEnum.CLOCKIN)
      })
    }

    return progressData
  }

  private createLiveTimerWithBreak(baseTime$: Observable<string>) {
    return combineLatest([
      this.latestPunchIn$,
      baseTime$,
      this.totalBreakHoursToday$,
      interval(60000).pipe(startWith(0)),
      this.settling$
    ]).pipe(
      filter(([, , , , settling]) => !settling),
      map(([latestPunchIn, totalWorked, breakTime]) => {
        const workedMinutes = this.parseTimeToMinutes(totalWorked)
        const breakMinutes = this.parseTimeToMinutes(breakTime)

        let totalMinutes = workedMinutes + breakMinutes

        if (
          latestPunchIn?.clockIn &&
          latestPunchIn.workStatus === this.workstatusEnum.CLOCKIN &&
          !latestPunchIn.clockOut
        ) {
          const diffMinutes = Math.floor(
            (Date.now() - new Date(latestPunchIn.clockIn).getTime()) / 60000
          )
          if (diffMinutes > 0) totalMinutes += diffMinutes
        }

        return this.formatMinutes(totalMinutes)
      }),
      shareReplay(1)
    )
  }

  getWorkStatusColor(status: string | null) {
    switch (status) {
      case this.workstatusEnum.BREAK:
        return 'bg-warning'
      case this.workstatusEnum.PRESENT:
        return 'bg-success'
      case this.workstatusEnum.CLOCKIN:
        return 'bg-success'
      case 'Uninformed':
        return 'bg-info'
      case 'Overtime':
        return 'bg-secondary'
      default:
        return 'bg-white' // Default color for unknown status
    }
  }

  loadAttendances() {
    const params: any = {}
    // params.userId = this.user?.id
    // if (this.leaveType ) {
    //   params.leaveType = this.leaveType
    // }
    // if (this.status) {
    //   params.workStatus = this.status
    // }
    // if (this.dateRange?.startDate && this.dateRange?.endDate) {
    //   params.fromDate = this.dateRange.startDate.format('YYYY-MM-DD')
    //   params.toDate = this.dateRange.endDate.format('YYYY-MM-DD')
    // }
    this.store.dispatch(
      loadEmployeeAttendance({
        id: this.user?.id,
        // params: null
        params: new URLSearchParams(params).toString()
      })
    )
  }

  getEmployeeImage(employee: User): string {
    if (employee?.picture && this.employeeImages[employee.picture]) {
      return this.employeeImages[employee.picture]
    } else if (employee.picture) {
      const imageUrl = this.apiEndpoint + '/uploads/' + employee.picture // Assuming this is the correct path
      this.authService.getImage(imageUrl).subscribe(
        imageBlob => {
          const objectURL = URL.createObjectURL(imageBlob)
          // this.employeeImages[employee.picture ?? this.defaultImg] = objectURL // Store the object URL
          this.employeeImages[employee.picture ?? ''] = objectURL // Store the object URL
        },
        error => {
          console.error('Error fetching image:', error)
        }
      )
    }
    // return this.defaultImg
    return ''
  }

  // readonly totalWorkHoursIncludingCurrent$ = combineLatest([
  //   this.latestPunchIn$,
  //   this.totalWorkHoursToday$,
  //   interval(60000).pipe(startWith(0)) // update every minute
  // ]).pipe(
  //   map(([latestPunchIn, totalWorked]) => {
  //     // Convert "0h 17m" => total hours as number
  //     const workedMatch = /(?:(\d+)h)?\s*(?:(\d+)m)?/.exec(totalWorked ?? '')
  //     const workedHours = workedMatch ? parseInt(workedMatch[1] || '0', 10) : 0
  //     const workedMinutes = workedMatch ? parseInt(workedMatch[2] || '0', 10) : 0
  //     let total = workedHours + workedMinutes / 60

  //     // Add current ongoing work duration if still clocked in
  //     if (
  //       latestPunchIn?.clockIn &&
  //       latestPunchIn.workStatus === 'ClockIn' &&
  //       !latestPunchIn.clockOut
  //     ) {
  //       const clockInTime = new Date(latestPunchIn.clockIn).getTime()
  //       const now = Date.now()
  //       const diffInMs = now - clockInTime
  //       const diffInHours = diffInMs / (1000 * 60 * 60)
  //       total += diffInHours
  //     }

  //     if (
  //       latestPunchIn?.clockIn &&
  //       latestPunchIn.workStatus === 'ClockIn' &&
  //       !!latestPunchIn.clockOut
  //     ) {
  //       const clockInTime = new Date(latestPunchIn.clockIn).getTime()
  //       const clockOutTime = new Date(latestPunchIn.clockOut).getTime()
  //       const diffInMs = clockOutTime - clockInTime
  //       const diffInHours = diffInMs / (1000 * 60 * 60)
  //       total += diffInHours
  //     }

  //     // Format back to "Xh Ym"
  //     const hours = Math.floor(total)
  //     const minutes = Math.round((total - hours) * 60)

  //     return `${hours}h ${minutes}m`
  //   })
  // )

  private createLiveTimer(baseTime$: Observable<string>) {
    return combineLatest([
      this.latestPunchIn$,
      baseTime$,
      interval(60000).pipe(startWith(0)) // update every minute
    ]).pipe(
      map(([latestPunchIn, totalWorked]) => {
        // 🔹 Convert "0h 17m" → hours number
        const workedMatch = /(?:(\d+)h)?\s*(?:(\d+)m)?/.exec(totalWorked ?? '')
        const workedHours = workedMatch ? parseInt(workedMatch[1] || '0', 10) : 0
        const workedMinutes = workedMatch ? parseInt(workedMatch[2] || '0', 10) : 0

        let total = workedHours + workedMinutes / 60

        // 🔹 Add running time if currently clocked in
        if (
          latestPunchIn?.clockIn &&
          latestPunchIn.workStatus === this.workstatusEnum.CLOCKIN &&
          !latestPunchIn.clockOut
        ) {
          const clockInTime = new Date(latestPunchIn.clockIn).getTime()
          const now = Date.now()
          const diffInMs = now - clockInTime
          if (diffInMs > 0) {
            const diffInHours = diffInMs / (1000 * 60 * 60)
            total += diffInHours
          }
        }

        // 🔹 Format back to "Xh Ym"
        const hours = Math.floor(total)
        const minutes = Math.floor((total - hours) * 60)

        return `${hours}h ${minutes}m`
      })
    )
  }

  private minuteTicker$ = interval(60000).pipe(
    startWith(0),
    shareReplay({ bufferSize: 1, refCount: true })
  )

  readonly totalWorkHoursTodayCurrent$ = combineLatest([
    this.store.select(selectTotalWorkHoursToday),
    this.latestPunchIn$,
    this.minuteTicker$
    //  interval(1000).pipe(startWith(0)) // update every second
  ]).pipe(
    map(([totalWorked, latestPunchIn]) => {
      const match = /(?:(\d+)h)?\s*(?:(\d+)m)?/.exec(totalWorked ?? '')
      const baseHours = match ? parseInt(match[1] || '0', 10) : 0
      const baseMinutes = match ? parseInt(match[2] || '0', 10) : 0

      let totalMs = (baseHours * 60 + baseMinutes) * 60 * 1000

      if (
        latestPunchIn?.clockIn &&
        latestPunchIn.workStatus === this.workstatusEnum.CLOCKIN &&
        !latestPunchIn.clockOut
      ) {
        const clockInTime = new Date(latestPunchIn.clockIn).getTime()
        // totalMs += Date.now() - clockInTime
        const diffMs = Date.now() - clockInTime
        if (diffMs > 0) totalMs += diffMs
      }

      const hours = Math.floor(totalMs / (1000 * 60 * 60))
      const minutes = Math.floor((totalMs / (1000 * 60)) % 60)

      return `${hours}h ${minutes}m`
    }),
    shareReplay(1)
  )

  // readonly totalWorkHoursIncludingCurrent$ = combineLatest([
  //   this.latestPunchIn$,
  //   this.totalWorkHoursToday$,
  //   interval(60000).pipe(startWith(0)) // update every minute
  // ]).pipe(
  //   map(([latestPunchIn, totalWorked]) => {
  //     // Convert "0h 17m" => total hours as number
  //     const workedMatch = /(?:(\d+)h)?\s*(?:(\d+)m)?/.exec(totalWorked ?? '')
  //     const workedHours = workedMatch ? parseInt(workedMatch[1] || '0', 10) : 0
  //     const workedMinutes = workedMatch ? parseInt(workedMatch[2] || '0', 10) : 0
  //     let total = workedHours + workedMinutes / 60

  //     // ✅ Only add if ongoing punch (not finished yet)
  //     if (
  //       latestPunchIn?.clockIn &&
  //       latestPunchIn.workStatus === this.workstatusEnum.CLOCKIN &&
  //       !latestPunchIn.clockOut
  //     ) {
  //       const clockInTime = new Date(latestPunchIn.clockIn).getTime()
  //       const now = Date.now()
  //       const diffInMs = now - clockInTime
  //       if (diffInMs > 0) {
  //         const diffInHours = diffInMs / (1000 * 60 * 60)
  //         total += diffInHours
  //       }
  //     }
  //     // Normalize total to prevent negative or invalid values
  //     if (total < 0) total = 0
  //     // 🔥 CONVERT TO PERCENTAGE
  //     const percent = Math.min((total / this.maxWorkHours) * 100, 100)

  //     // 🔥 UPDATE CIRCLE LIVE
  //     this.updateCircle(percent)
  //     // ❌ Remove the block that adds finished punches
  //     // if (latestPunchIn?.clockIn && latestPunchIn.workStatus === 'ClockIn' && !!latestPunchIn.clockOut) {
  //     //   ...
  //     // }

  //     // Format back to "Xh Ym"
  //     const hours = Math.floor(total)
  //     const rawMinutes = Math.round((total - hours) * 60)
  //     // If minutes >= 60, convert to hours
  //     const minutes = rawMinutes >= 60 ? 0 : rawMinutes
  //     const finalHours = rawMinutes >= 60 ? hours + 1 : hours
  //     // const minutes = Math.round((total - hours) * 60)

  //     return `${finalHours}h ${minutes}m`
  //   })
  // )

  readonly totalWorkHoursIncludingCurrent$ = combineLatest([
    this.latestPunchIn$,
    this.totalWorkHoursToday$,
    this.totalBreakHoursToday$,
    this.minuteTicker$,
    this.settling$
  ]).pipe(
    filter(([, , , , settling]) => !settling),
    map(([latestPunchIn, totalWorked, breakTime]) => {
      let totalMinutes = this.parseTimeToMinutes(totalWorked) + this.parseTimeToMinutes(breakTime)

      if (
        latestPunchIn?.clockIn &&
        latestPunchIn.workStatus === this.workstatusEnum.CLOCKIN &&
        !latestPunchIn.clockOut
      ) {
        const diffMinutes = Math.floor(
          (Date.now() - new Date(latestPunchIn.clockIn).getTime()) / 60000
        )
        if (diffMinutes > 0) totalMinutes += diffMinutes
      }

      if (totalMinutes < 0) totalMinutes = 0

      this.updateCircle(Math.min((totalMinutes / (this.maxWorkHours * 60)) * 100, 100))

      return this.formatMinutes(totalMinutes)
    })
  )

  readonly liveTodayWithBreak$ = combineLatest([
    this.store.select(selectTotalWorkHoursToday),
    this.store.select(selectTotalBreakHoursToday),
    this.latestPunchIn$,
    this.minuteTicker$
  ]).pipe(
    map(([work, breakTime, latestPunchIn]) => {
      let totalMinutes = this.parseTimeToMinutes(work) + this.parseTimeToMinutes(breakTime)

      if (
        latestPunchIn?.clockIn &&
        latestPunchIn.workStatus === this.workstatusEnum.CLOCKIN &&
        !latestPunchIn.clockOut
      ) {
        const diffMinutes = Math.floor(
          (Date.now() - new Date(latestPunchIn.clockIn).getTime()) / 60000
        )

        if (diffMinutes > 0) {
          totalMinutes += diffMinutes
        }
      }

      return this.formatMinutes(totalMinutes)
    }),
    shareReplay(1)
  )

  getInitials(firstName = '', lastName = ''): string {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
  }

  getTeamMembersOfEmployee() {
    const params = ''
    const page = 1
    const limit = 5
    this.userService.getTeamMembersOfEmployee(this.employeeId, params, page, limit).subscribe({
      next: res => {
        this.teamMembers = res.teamMembers.map((member: any) => ({
          ...member,
          showInitials: !member.picture
        }))
      },
      error: err => {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch team members:', err)
      }
    })
  }

  getTeamMemberBirthday(businessId: string) {
    this.userService.getTeamMemberBirthday(businessId).subscribe({
      next: res => {
        this.birthdayEmployees = res
      },
      error: err => {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch team members:', err)
      }
    })
  }

  // getNotifications(userId: string) {
  //   this.isNotificationsLoading = true
  //   const search = ''
  //   const page = 1
  //   const limit = 5

  //   this.notificationService.list(userId, search, page, limit).subscribe({
  //     next: res => {
  //       this.notifications = (res.notifications || []).map((n: Notification) => ({
  //         ...n,
  //         createdAt: new Date(n.createdAt as string | Date)
  //       }))
  //       this.isNotificationsLoading = false
  //     },

  //     error: err => {
  //       // eslint-disable-next-line no-console
  //       console.error('Failed to fetch team members:', err)
  //       this.isNotificationsLoading = false
  //     }
  //   })
  // }

  //optimized 12 march 2026 gps
  getNotifications(userId: string): Observable<Notification[]> {
    const search = ''
    const page = 1
    const limit = 5

    return this.notificationService.list(userId, search, page, limit).pipe(
      map(res =>
        (res.notifications || []).map((n: Notification) => ({
          ...n,
          createdAt: new Date(n.createdAt as string | Date)
        }))
      ),
      catchError(err => {
        console.error('Failed to fetch notifications:', err)
        return of([]) // return empty list instead of void
      }),
      tap(() => (this.isNotificationsLoading = false)),
      shareReplay(1)
    )
  }

  redirectToBilling() {
    this.router.navigate([eps.planAndBilling.planPath])
  }

  // private initAttendanceChart() {
  //   this.attendanceChartOptions = {
  //     series: [],
  //     chart: {
  //       type: 'donut',
  //       height: 255,

  //       animations: {
  //         enabled: false
  //       },
  //       events: {
  //         dataPointSelection: () => {
  //           this.isChartExpanded = true
  //         }
  //       }
  //     },
  //     labels: [],
  //     colors: [],
  //     dataLabels: {
  //       enabled: true,
  //       formatter: (val, opts) => {
  //         return opts.w.globals.series[opts.seriesIndex]
  //       },
  //       style: {
  //         fontSize: '14px'
  //         // colors: []
  //       }
  //       // dropShadow: {
  //       //   enabled: false
  //       // }
  //     },
  //     legend: {
  //       show: false
  //     },
  //     stroke: {
  //       width: 2
  //     },
  //     tooltip: {
  //       enabled: true,
  //       fillSeriesColor: true,
  //       x: {
  //         show: false
  //       },
  //       y: {
  //         title: {
  //           formatter: (seriesName: string) => seriesName + ':'
  //         }
  //       }
  //     },
  //     plotOptions: {
  //       pie: {
  //         dataLabels: {
  //           offset: 25,
  //           minAngleToShowLabel: 0
  //         }
  //       }
  //     },
  //     responsive: [
  //       {
  //         breakpoint: 480,
  //         options: {
  //           chart: {
  //             width: 220
  //           }
  //         }
  //       }
  //     ]
  //   }
  // }

  private initAttendanceChart() {
    this.attendanceChartOptions = {
      series: [],
      chart: {
        type: 'donut',
        height: 255,
        animations: {
          enabled: false
        },
        events: {
          dataPointSelection: () => {
            this.isChartExpanded = true
          }
        }
      },
      labels: [],
      colors: [],
      dataLabels: {
        enabled: false,
        formatter: (val, opts) => {
          return opts.w.globals.series[opts.seriesIndex]
        },
        style: {
          fontSize: '14px'
        }
      },
      legend: {
        show: false
      },
      stroke: {
        width: 2
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: true,
        x: {
          show: false
        },
        y: {
          title: {
            formatter: (seriesName: string) => seriesName + ':'
          }
        }
      },
      // plotOptions: {
      //   pie: {
      //     // expandOnClick: false,
      //     customScale: 0.9,
      //     dataLabels: {
      //       offset: 35,
      //       minAngleToShowLabel: 0
      //     },
      //     donut: {
      //       size: '65%'
      //     }
      //   }
      // },
      // grid: {
      //   padding: {
      //     top: 20,
      //     bottom: 20,
      //     left: 20,
      //     right: 20
      //   }
      // },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 220
            }
          }
        }
      ]
    }
  }

  private bindAttendanceChartData() {
    // this.clockInOutCount$.pipe(takeUntil(this.destroyed$)).subscribe(count => {
    this.attendanceData$.pipe(takeUntil(this.destroyed$)).subscribe(count => {
      if (!count?.attendanceDetails) return

      const series = [
        Number(count.attendanceDetails.onTime || 0),
        Number(count.attendanceDetails.lateAttendance || 0),
        Number(count.attendanceDetails.earlyLeave || 0),
        Number(count.attendanceDetails.absent || 0),
        Number(count.attendanceDetails.workFromHome || 0),
        Number(count.attendanceDetails.workedDays || 0)
        // Number(count.attendanceDetails.sickLeave || 0)
      ]

      // const labels = ['On Time', 'Late Attendance', 'Work From Home', 'Absent', 'Sick Leave']
      const labels = [
        'On Time',
        'Late Attendance',
        'Early Leave',
        'Absent',
        'Work From Home',
        'Worked Days'
      ]

      // const colors = ['#03C95A', '#0C4B5E', '#F26522', '#E70D0D', '#F59E0B']
      // const colors = ['#03C95A', '#0C4B5E', '#0dcaf0', '#F26522', '#E70D0D', '#9E9E9E']
      const colors = ['#03C95A', '#0C4B5E', '#0dcaf0', '#E70D0D', '#F26522', '#9E9E9E']

      const filtered = series
        .map((value, index) => ({
          value,
          label: labels[index],
          color: colors[index]
        }))
        .filter(item => item.value > 0)

      if (filtered.length === 0) {
        this.attendanceChartOptions = {
          ...this.attendanceChartOptions
          // series: [1],
          // labels: ['No Data']
          // colors: ['#E5E7EB']
        }
        return
      }

      this.attendanceChartOptions = {
        ...this.attendanceChartOptions,
        series: filtered.map(i => i.value),
        labels: filtered.map(i => i.label),
        colors: filtered.map(i => i.color)
      }
    })
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedOnSlice = (event.target as HTMLElement).closest('.apexcharts-series path')
    if (this.isChartExpanded && !clickedOnSlice) {
      this.isChartExpanded = false
      this.attendanceChartOptions = {
        ...this.attendanceChartOptions,
        chart: {
          ...this.attendanceChartOptions.chart,
          height: 255
        }
      }
    }
  }

  generateProgress() {
    const startHour = 9
    const startMinute = 30

    const now = new Date()
    const currentHour = now.getHours()
    const currentMinute = now.getMinutes()

    const startTotal = startHour * 60 + startMinute
    const currentTotal = currentHour * 60 + currentMinute

    const totalMinutes = 24 * 60

    const progress = ((currentTotal - startTotal) / totalMinutes) * 360

    this.progressRotation = `rotate(${progress - 90}deg)`
  }

  updateCircle(value: number) {
    const deg = (value / 100) * 360

    if (value <= 50) {
      this.rightRotation = `rotate(${deg}deg)`
      this.leftRotation = 'rotate(0deg)'
    } else {
      this.rightRotation = 'rotate(180deg)'
      this.leftRotation = `rotate(${deg - 180}deg)`
    }
  }

  // updateClock() {
  //   const start = new Date(this.clockInTime).getTime()
  //   const now = Date.now()

  //   const diffMs = Math.max(now - start, 0)
  //   const totalDayMs = 24 * 60 * 60 * 1000

  //   const percent = Math.min((diffMs / totalDayMs) * 100, 100)

  //   const hours = Math.floor(diffMs / (1000 * 60 * 60))
  //   const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))

  //   this.chartOptions = {
  //     series: [this.clockPercent],

  //     chart: {
  //       type: 'radialBar',
  //       height: 320
  //     },

  //     plotOptions: {
  //       radialBar: {
  //         startAngle: -90, // 🔥 TOP START (12 o'clock)
  //         endAngle: 270, // full circle

  //         hollow: {
  //           size: '70%'
  //         },

  //         track: {
  //           background: '#e5e7eb'
  //         },

  //         dataLabels: {
  //           show: false
  //         }
  //       }
  //     },

  //     fill: {
  //       colors: ['#22c55e'] // green only
  //     },

  //     stroke: {
  //       lineCap: 'round'
  //     },

  //     labels: ['Work']
  //   }
  // }

  updateClock() {
    this.chartOptions = {
      series: [this.clockPercent],

      chart: {
        type: 'radialBar',
        height: 320
      },

      plotOptions: {
        radialBar: {
          // 🔥 DYNAMIC START (clockIn position)
          startAngle: this.clockStartAngle - 90,

          // 🔥 END = start + progress
          endAngle: this.clockStartAngle - 90 + (this.clockPercent / 100) * 360,

          hollow: {
            size: '70%'
          },

          track: {
            background: '#e5e7eb'
          },

          dataLabels: {
            show: false
          }
        }
      },

      fill: {
        colors: ['#22c55e']
      },

      stroke: {
        lineCap: 'round'
      },

      labels: ['Work']
    }
  }

  getRadialSeries() {
    return this.progressData.map(p => {
      return parseFloat(p.width) // convert "18%" → 18
    })
  }

  getColorCode(colorClass: string): string {
    const map: any = {
      'bg-success': '#28a745',
      'bg-warning': '#ffc107',
      'bg-info': '#17a2b8',
      'bg-white': '#ffffff'
    }

    return map[colorClass] || '#999999'
  }

  // updateClockFromProgress(progressData: any[]) {
  //   if (!progressData?.length) return

  //   // 🔥 total worked minutes from progress bars
  //   const totalMinutes = progressData.reduce((sum, p) => {
  //     return sum + (p.minutes || 0)
  //   }, 0)

  //   const totalDayMinutes = 24 * 60

  //   // 🔥 convert to percent (0–100)
  //   this.clockPercent = Math.min((totalMinutes / totalDayMinutes) * 100, 100)

  //   // ⏱ label
  //   const hours = Math.floor(totalMinutes / 60)
  //   const minutes = totalMinutes % 60

  //   this.totalTimeLabel = `${hours}h ${minutes}m`

  //   // 🔥 update radial chart
  //   this.chartOptions = {
  //     series: [this.clockPercent],

  //     chart: {
  //       type: 'radialBar',
  //       height: 320
  //     },

  //     plotOptions: {
  //       radialBar: {
  //         startAngle: -90,
  //         endAngle: 270,
  //         hollow: {
  //           size: '70%'
  //         },
  //         track: {
  //           background: '#e5e7eb'
  //         },
  //         dataLabels: {
  //           show: false
  //         }
  //       }
  //     },

  //     fill: {
  //       colors: ['#22c55e']
  //     },

  //     stroke: {
  //       lineCap: 'round'
  //     },

  //     labels: ['Work']
  //   }
  // }

  // private updateClockFromProgress(progressData: any[]) {
  //   if (!progressData?.length) return

  //   const segments = this.convertProgressToClockArc(progressData)
  //   const work = segments.find(s => s.color === 'bg-success')
  //   if (!work) return

  //   const now = new Date()
  //   const currentMin = now.getHours() * 60 + now.getMinutes()

  //   const startMin = work.startMin

  //   // 🔥 HANDLE CROSS MIDNIGHT (important future-safe)
  //   let diff = currentMin - startMin
  //   if (diff < 0) {
  //     diff += 24 * 60
  //   }

  //   // 🔥 percent of FULL DAY
  //   const percent = (diff / (24 * 60)) * 100

  //   this.clockPercent = Math.min(Math.max(percent, 0), 100)

  //   this.attendancePercent = Math.min((diff / (this.maxWorkHours * 60)) * 100, 100)
  //   this.updateCircle(this.attendancePercent)

  //   // 🔥 IMPORTANT: store start angle
  //   this.clockStartAngle = (startMin / (24 * 60)) * 360

  //   this.updateClock()
  // }
  private updateClockFromProgress(_progressData: any[]) {
    const latest = this.latestPunchIn
    if (!latest?.clockIn) return

    const clockInTime = new Date(latest.clockIn).getTime()
    const now = Date.now()

    // If already clocked out, use clockOut time; else use now
    const endTime =
      latest.workStatus === this.workstatusEnum.CLOCKIN && !latest.clockOut
        ? now
        : latest.clockOut
          ? new Date(latest.clockOut).getTime()
          : now

    const diffMs = Math.max(endTime - clockInTime, 0)
    const diffMinutes = diffMs / 60000

    // ✅ 24-hour ring percent
    const percentOfDay = Math.min((diffMinutes / (24 * 60)) * 100, 100)
    this.clockPercent = percentOfDay

    // ✅ maxWorkHours based circle percent (this drives the small circle)
    this.attendancePercent = Math.min((diffMinutes / (this.maxWorkHours * 60)) * 100, 100)

    // start angle from clock-in time (only for the radial chart)
    const clockInDate = new Date(latest.clockIn)
    const startMin = clockInDate.getHours() * 60 + clockInDate.getMinutes()
    this.clockStartAngle = (startMin / (24 * 60)) * 360

    this.updateCircle(this.attendancePercent)
    this.updateClock()
  }
  // generateClockLabels(): string[] {
  //   const labels: string[] = []

  //   for (let i = 0; i < 24; i++) {
  //     labels.push(`${i.toString().padStart(2, '0')}:00`)
  //   }

  //   return labels
  // }

  generateClockLabels(): string[] {
    return Array.from({ length: 24 }, (_, i) => `${i.toString().padStart(2, '0')}:00`)
  }

  getLabelPosition(index: number): string {
    const angle = (index * 360) / 24

    return `
    transform:
      rotate(${angle}deg)
      translate(140px)
      rotate(-360deg)
  `
  }

  // getLabelPosition(index: number): string {
  //   const angle = (index * 360) / 24

  //   return `
  //   transform:
  //     rotate(${angle}deg)
  //     translate(140px)
  //     rotate(-${angle}deg)
  // `
  // }

  private convertProgressToClockArc(progressData: any[]) {
    const totalMinutesInDay = 24 * 60

    let segments: any[] = []

    progressData.forEach(p => {
      const startPercent = parseFloat(p.start)
      const widthPercent = parseFloat(p.width)

      const startMin = (startPercent / 100) * totalMinutesInDay
      const durationMin = (widthPercent / 100) * totalMinutesInDay

      segments.push({
        startMin,
        endMin: startMin + durationMin,
        color: p.color
      })
    })

    return segments
  }

  // buildGradient() {
  //   const segments = [
  //     { label: 'Work', color: '#22c55e', value: this.workMinutes },
  //     { label: 'Break', color: '#f59e0b', value: this.breakMinutes },
  //     { label: 'Overtime', color: '#6366f1', value: this.overtimeMinutes }
  //   ]

  //   const sumUsed = segments.reduce((s, seg) => s + seg.value, 0)
  //   const total = Math.max(this.totalShiftMinutes || 1, sumUsed) // overflow safe
  //   const idle = Math.max(total - sumUsed, 0)

  //   this.segmentsForLegend = segments.filter(s => s.value > 0)

  //   const allSegments = [...segments, { label: 'Remaining', color: '#eef0f4', value: idle }]

  //   let cumulative = 0
  //   const stops: string[] = []

  //   allSegments.forEach(seg => {
  //     if (seg.value <= 0) return
  //     const startPct = (cumulative / total) * 100
  //     cumulative += seg.value
  //     const endPct = (cumulative / total) * 100
  //     stops.push(`${seg.color} ${startPct}% ${endPct}%`)
  //   })

  //   this.ringBackground = `conic-gradient(${stops.join(', ')})`
  // }

  // buildGradient() {
  //   const COLOR = {
  //     work: '#22c55e',
  //     break: '#f59e0b',
  //     overtime: '#6366f1'
  //   }

  //   const shiftMin = this.maxWorkHours * 60

  //   const toMin = (t: Date | string) => new Date(t).getTime() / 60000

  //   const nowMin = Date.now() / 60000

  //   const records = [...this.dayRecords]
  //     .filter(r => r.clockIn)
  //     .sort((a, b) => new Date(a.clockIn).getTime() - new Date(b.clockIn).getTime())

  //   type Seg = {
  //     type: 'work' | 'break' | 'overtime'
  //     minutes: number
  //   }

  //   const segs: Seg[] = []

  //   let prevEnd: number | null = null
  //   let workAccum = 0

  //   for (const r of records) {
  //     const rawStart = toMin(r.clockIn)
  //     const end = r.clockOut ? toMin(r.clockOut) : nowMin

  //     // Gap = break
  //     if (prevEnd !== null && rawStart > prevEnd) {
  //       segs.push({
  //         type: 'break',
  //         minutes: rawStart - prevEnd
  //       })
  //     }

  //     const start = prevEnd !== null ? Math.max(rawStart, prevEnd) : rawStart

  //     if (end <= start) continue

  //     const minutes = end - start

  //     if (r.workStatus === this.workstatusEnum.BREAK) {
  //       segs.push({
  //         type: 'break',
  //         minutes
  //       })
  //     } else {
  //       const room = Math.max(shiftMin - workAccum, 0)

  //       const normal = Math.min(minutes, room)

  //       const ot = minutes - normal

  //       if (normal > 0) {
  //         segs.push({
  //           type: 'work',
  //           minutes: normal
  //         })
  //       }

  //       if (ot > 0) {
  //         segs.push({
  //           type: 'overtime',
  //           minutes: ot
  //         })
  //       }

  //       workAccum += minutes
  //     }

  //     prevEnd = Math.max(end, prevEnd ?? end)
  //   }

  //   const used = segs.reduce((sum, s) => sum + s.minutes, 0)

  //   const total = Math.max(shiftMin, used, 1)

  //   const validSegs = segs.filter(s => s.minutes > 0)

  //   /*
  //    * SVG circle circumference
  //    *
  //    * r = 80
  //    * circumference = 2πr
  //    */
  //   const radius = 80
  //   const circumference = 2 * Math.PI * radius

  //   let accumulated = 0

  //   const built: {
  //     color: string
  //     dasharray: string
  //     dashoffset: number
  //   }[] = validSegs.map(s => {
  //     const fraction = s.minutes / total

  //     const segmentLength = fraction * circumference

  //     const dasharray = `${segmentLength} ${circumference - segmentLength}`

  //     const dashoffset = -accumulated

  //     accumulated += segmentLength

  //     return {
  //       color: COLOR[s.type],
  //       dasharray,
  //       dashoffset
  //     }
  //   })

  //   this.ringSegments = built

  //   const labels = {
  //     work: 'Work',
  //     break: 'Break',
  //     overtime: 'Overtime'
  //   }

  //   this.segmentsForLegend = (['work', 'break', 'overtime'] as const)
  //     .filter(t => segs.some(s => s.type === t))
  //     .map(t => ({
  //       label: labels[t],
  //       color: COLOR[t],
  //       value: 0
  //     }))
  // }

  buildGradient() {
    const COLOR = {
      work: '#22c55e',
      break: '#f59e0b',
      overtime: '#6366f1'
    }
    const shiftMin = this.maxWorkHours * 60
    const toMin = (t: Date | string) => new Date(t).getTime() / 60000
    const nowMin = Date.now() / 60000

    const records = [...this.dayRecords]
      .filter(r => r.clockIn)
      .sort((a, b) => new Date(a.clockIn).getTime() - new Date(b.clockIn).getTime())

    type Seg = { type: 'work' | 'break' | 'overtime'; minutes: number }
    const segs: Seg[] = []
    let prevEnd: number | null = null
    let workAccum = 0

    for (const r of records) {
      const rawStart = toMin(r.clockIn)
      const end = r.clockOut ? toMin(r.clockOut) : nowMin

      if (prevEnd !== null && rawStart > prevEnd) {
        segs.push({ type: 'break', minutes: rawStart - prevEnd })
      }

      const start = prevEnd !== null ? Math.max(rawStart, prevEnd) : rawStart
      if (end <= start) continue

      const minutes = end - start

      if (r.workStatus === this.workstatusEnum.BREAK) {
        segs.push({ type: 'break', minutes })
      } else {
        const room = Math.max(shiftMin - workAccum, 0)
        const normal = Math.min(minutes, room)
        const ot = minutes - normal
        if (normal > 0) segs.push({ type: 'work', minutes: normal })
        if (ot > 0) segs.push({ type: 'overtime', minutes: ot })
        workAccum += minutes
      }

      prevEnd = Math.max(end, prevEnd ?? end)
    }

    const used = segs.reduce((s, x) => s + x.minutes, 0)
    const total = Math.max(shiftMin, used, 1)
    const validSegs = segs.filter(s => s.minutes > 0)

    const MIN_FRACTION = 4 / 360 // MIN_ANGLE 4deg jaisa minimum share
    const radius = 80
    const circumference = 2 * Math.PI * radius

    const rawFractions = validSegs.map(s => s.minutes / total)
    const clampedFractions = rawFractions.map(f => Math.max(f, MIN_FRACTION))
    const clampedTotal = clampedFractions.reduce((a, b) => a + b, 0)
    const scale = clampedTotal > 1 ? 1 / clampedTotal : 1
    const finalFractions = clampedFractions.map(f => f * scale)

    // overlap: circumference ke hisaab se pixel-length me, taaki chhote segment ke corners grey me dabein
    const OVERLAP_PX = 1.5

    let accumulated = 0
    const built: { color: string; dasharray: string; dashoffset: number }[] = validSegs.map(
      (s, i) => {
        const fraction = finalFractions[i]
        const rawLength = fraction * circumference
        const isSmall = rawLength < 12
        const overlap = isSmall ? OVERLAP_PX * 1.8 : OVERLAP_PX

        // segment ko dono taraf overlap ke barabar bada karo, aur shuru bhi utna hi pehle karo
        const segmentLength = rawLength + overlap * 2
        const dashoffset = -(accumulated - overlap)

        accumulated += rawLength

        return {
          color: COLOR[s.type],
          dasharray: `${segmentLength} ${circumference - segmentLength}`,
          dashoffset
        }
      }
    )

    this.ringSegments = built

    const labels = { work: 'Work', break: 'Break', overtime: 'Overtime' }
    this.segmentsForLegend = (['work', 'break', 'overtime'] as const)
      .filter(t => segs.some(s => s.type === t))
      .map(t => ({ label: labels[t], color: COLOR[t], value: 0 }))
  }

  private polarToCartesian(cx: number, cy: number, r: number, angleDeg: number) {
    const angleRad = ((angleDeg - 90) * Math.PI) / 180
    return {
      x: cx + r * Math.cos(angleRad),
      y: cy + r * Math.sin(angleRad)
    }
  }

  private describeDonutSegment(
    cx: number,
    cy: number,
    outerR: number,
    innerR: number,
    startAngle: number,
    endAngle: number
  ): string {
    const sweep = Math.min(endAngle - startAngle, 359.999)

    const outerStart = this.polarToCartesian(cx, cy, outerR, startAngle)
    const outerEnd = this.polarToCartesian(cx, cy, outerR, startAngle + sweep)

    const innerStart = this.polarToCartesian(cx, cy, innerR, startAngle)

    const innerEnd = this.polarToCartesian(cx, cy, innerR, startAngle + sweep)

    const largeArcFlag = sweep > 180 ? 1 : 0

    return [
      `M ${outerStart.x} ${outerStart.y}`,
      `A ${outerR} ${outerR} 0 ${largeArcFlag} 1 ${outerEnd.x} ${outerEnd.y}`,
      `L ${innerEnd.x} ${innerEnd.y}`,
      `A ${innerR} ${innerR} 0 ${largeArcFlag} 0 ${innerStart.x} ${innerStart.y}`,
      'Z'
    ].join(' ')
  }

  private statusHex(status: string | null): string {
    switch (status) {
      case this.workstatusEnum.BREAK:
        return '#f59e0b'
      case 'Overtime':
        return '#6366f1'
      case this.workstatusEnum.PRESENT:
      case this.workstatusEnum.CLOCKIN:
        return '#22c55e'
      default:
        return '#22c55e'
    }
  }

  // buildDayGradient() {
  //   const DAY = 1440
  //   const track = '#eef0f4'
  //   const toMin = (t: Date | string) => {
  //     const d = new Date(t)
  //     return d.getHours() * 60 + d.getMinutes()
  //   }

  //   const segs = [...this.dayRecords]
  //     .filter(r => r.clockIn)
  //     .sort((a, b) => new Date(a.clockIn).getTime() - new Date(b.clockIn).getTime())
  //     .map(r => ({
  //       start: toMin(r.clockIn),
  //       end: r.clockOut ? toMin(r.clockOut) : toMin(new Date()),
  //       color: this.statusHex(r.workStatus || this.workstatusEnum.CLOCKIN),
  //       status: r.workStatus
  //     }))
  //     .filter(s => s.end > s.start)

  //   const pct = (m: number) => (m / DAY) * 100
  //   const stops: string[] = []
  //   let cursor = 0

  //   segs.forEach(s => {
  //     const start = Math.max(s.start, cursor) // overlap safe
  //     if (s.end <= start) return
  //     if (start > cursor) stops.push(`${track} ${pct(cursor)}% ${pct(start)}%`)
  //     stops.push(`${s.color} ${pct(start)}% ${pct(s.end)}%`)
  //     cursor = s.end
  //   })
  //   if (cursor < DAY) stops.push(`${track} ${pct(cursor)}% 100%`)

  //   this.ringBackground = `conic-gradient(${stops.join(', ')})`

  //   // legend: sirf wahi jo aaj use hue
  //   const used = new Set(segs.map(s => s.color))
  //   this.segmentsForLegend = [
  //     { label: 'Work', color: '#22c55e', value: 0 },
  //     { label: 'Break', color: '#f59e0b', value: 0 },
  //     { label: 'Overtime', color: '#6366f1', value: 0 }
  //   ].filter(l => used.has(l.color))

  //   // current time marker
  //   const now = new Date()
  //   this.nowAngle = ((now.getHours() * 60 + now.getMinutes()) / DAY) * 360
  // }

  // getHourLabelStyle(h: number) {
  //   const a = (h / 24) * 360
  //   return {
  //     transform: `translate(-50%, -50%) rotate(${a}deg) translateY(-75px) rotate(${-a}deg)`
  //   }
  // }
}

export interface AttendanceChartOptions {
  series: ApexNonAxisChartSeries
  chart: ApexChart
  labels: string[]
  responsive: ApexResponsive[]
  legend: ApexLegend
  dataLabels: ApexDataLabels
  colors: string[]
  stroke: ApexStroke
  tooltip: ApexTooltip
  plotOptions?: ApexPlotOptions
  grid?: ApexGrid
}
